import { render, staticRenderFns } from "./WagonOrdering.vue?vue&type=template&id=b126db7a&scoped=true&"
import script from "./WagonOrdering.vue?vue&type=script&lang=js&"
export * from "./WagonOrdering.vue?vue&type=script&lang=js&"
import style0 from "./WagonOrdering.vue?vue&type=style&index=0&id=b126db7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b126db7a",
  null
  
)

export default component.exports